(function () {
	window.addEventListener('DOMContentLoaded', function () {
		class Scroll {
			constructor(params) {
				this.triggers = params.items;
			}
			init() {
				if (this.triggers == undefined) return;
				this.triggers.forEach(trigger => {
					this.constructScroller(trigger);
				});
			}
			constructScroller(trigger) {
				const hash = trigger.hash;
				const section = document.getElementById(hash.replace('#', ''));
				if (section == null) return;
				trigger.addEventListener('click', e => {
					e.preventDefault();
					let navigationHeight = document.querySelector('.site-header').offsetHeight;
					console.log(navigationHeight);
					gsap.to(window, {
						duration: 0.75,
						scrollTo: { y: section, offsetY: navigationHeight },

						onComplete: function () {
							// change the window hash without jumping
							history.pushState(null, null, hash);
							// trigger the event
							window.dispatchEvent(new HashChangeEvent('hashchange'));
						},
					});
				});
			}
		}

		const navLinks = document.querySelectorAll('.menu-item a');
		const buttonLinks = document.querySelectorAll('.buttons__button');
		const Links = document.querySelectorAll('.scroll-to');
		if (buttonLinks !== null) new Scroll({ items: buttonLinks }).init();
		if (navLinks !== null) new Scroll({ items: navLinks }).init();
		if (Links !== null) new Scroll({ items: Links }).init();
	});
})();
